import React from "react";
import { matchPath, Route, Routes, useNavigate } from "react-router-dom";

import { useState } from "react";
import { useMutation } from "@tanstack/react-query";

import { useRedirection } from "../../../../Hooks/useRedirection";
import { useRelativePath } from "../../../../Hooks/useNextRelativePath";
import { useWatchParameterOnRoutes } from "../../../../Hooks/useGetParameterOnRoutes";
import { useRequerPermissoes } from "../../../../Hooks/useRequerPermissoes";

import { Divider, Skeleton } from "antd";
import { Permissoes } from "../../../../Constants/Permissoes";
import { TypeViagem } from "../../../../Models/Domain/Viagem/Viagem";
import { ViagemService } from "../../../../Services/Domain/Viagem/ViagemService";

import ListagemDeViagens from "./Listagem";
import CadastroDeViagens from "./Cadastro";
import DetalhesDaViagem from "./Detalhes";

export const Viagem: React.FC<{}> = () => {
    const [viagemEmAlteracao, setViagemEmAlteracao] = useState<TypeViagem | undefined>(undefined);

    const navigate = useNavigate();
    const requerPermissoes = useRequerPermissoes();
    const [raiz, subrota] = useRelativePath();

    const rotaDeVisualizacao = matchPath({ path: "/detalhes" }, subrota);

    const obterViagem = useMutation({
        mutationFn: (codigo: number) => new ViagemService().listarViagem(codigo),
        onSuccess: (resposta) => {
            const viagem = resposta.data;
            setViagemEmAlteracao(viagem);
        },
        onError: () => {
            navigate(raiz);
        },
    });

    useRedirection([Permissoes.ListarViagens, Permissoes.CriarViagem, Permissoes.AtualizarViagem, Permissoes.DesativarViagem, Permissoes.AtivarViagem]);
    useWatchParameterOnRoutes({
        appliablePaths: [rotaDeVisualizacao],
        paramToWatch: "id",
        filters: [(p) => isNaN(Number(p))],
        onNotAccepted() {
            navigate(raiz);
        },
        onExists(param) {
            obterViagem.mutate(Number(param));
        },
    });

    return (
        <React.Fragment>
            <>
                <h2 style={{ marginTop: 0 }}>{rotaDeVisualizacao ? "Detalhes da Viagem" : "Cadastro de Viagem"} </h2>

                <Divider />

                <Routes>
                    {requerPermissoes.todas(Permissoes.ListarViagens) && (
                        <Route
                            path="*"
                            index
                            element={
                                <ListagemDeViagens
                                    hrefDoBotaoAdicionar={raiz + "/cadastro"}
                                    hrefDoBotaoDetalhes={(item) => {
                                        if (item.codigo) {
                                            return raiz + `/detalhes?id=${item.codigo}`;
                                        }
                                    }}
                                    aoSelecionarDetalhes={(item) => {
                                        if (item.codigo) {
                                            setViagemEmAlteracao(item);
                                        }
                                    }}
                                />
                            }
                        />
                    )}

                    {true && (
                        <Route
                            path="detalhes/*"
                            element={
                                viagemEmAlteracao == undefined ? (
                                    <Skeleton active />
                                ) : (
                                    <DetalhesDaViagem
                                        viagem={viagemEmAlteracao}
                                        voltar={() => {
                                            navigate(raiz);
                                        }}
                                    />
                                )
                            }
                        />
                    )}

                    {requerPermissoes.todas(Permissoes.CriarViagem) && (
                        <Route
                            path="/cadastro"
                            element={
                                <CadastroDeViagens
                                    aoCancelar={() => {
                                        navigate(raiz);
                                    }}
                                    depoisDeFinalizar={() => {
                                        navigate(raiz);
                                    }}
                                />
                            }
                        />
                    )}
                </Routes>
            </>
        </React.Fragment>
    );
};
